import React, { useCallback, useEffect, useRef, useState } from "react";
import useChangePage from "../../utils/navigation.js";
import { registerUser } from "../../services/api/userService.ts";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  InputGroup,
  InputGroupText,
  Toast,
  ToastBody,
  ToastHeader,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { s } from "framer-motion/client";

const Register = () => {
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("authUser"));
    if (userData) {
      setUserlvl(userData.user_ROLE_ID);
      console.log("ROLE connecté:", userData.user_ROLE_ID);
    } else {
      setUserlvl(0); // si pas connecté
    }
  }, []);

  const [userlvl, setUserlvl] = useState(null);
  const [username, setUsername] = useState("");
  const [surname, setSurname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confPassword, setConfPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confPasswordVisible, setConfPasswordVisible] = useState(false);
  const [roleId, setRoleId] = useState();

  // États pour les notifications
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  document.title = "Register | iXiMANAGER Admin Portal";

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleConfPasswordVisibility = () => {
    setConfPasswordVisible(!confPasswordVisible);
  };

  // Fonction de validation du formulaire
  const validateForm = () => {
    if (!username.trim()) {
      setToastMessage("Le nom d'utilisateur est requis");
      setShowErrorToast(true);
      return false;
    }
    if (!surname.trim()) {
      setToastMessage("Le nom de famille est requis");
      setShowErrorToast(true);
      return false;
    }
    if (!email.trim()) {
      setToastMessage("L'email est requis");
      setShowErrorToast(true);
      return false;
    }
    if (!phone.trim()) {
      setToastMessage("Le numéro de téléphone est requis");
      setShowErrorToast(true);
      return false;
    }
    if (!roleId) {
      setToastMessage("L'ID du rôle est requis");
      setShowErrorToast(true);
      return false;
    }
    if (!password.trim()) {
      setToastMessage("Le mot de passe est requis");
      setShowErrorToast(true);
      return false;
    }
    if (password !== confPassword) {
      setToastMessage("Les mots de passe ne correspondent pas");
      setShowErrorToast(true);
      return false;
    }
    if (password.length < 6) {
      setToastMessage("Le mot de passe doit contenir au moins 6 caractères");
      setShowErrorToast(true);
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setToastMessage("Veuillez entrer un email valide");
      setShowErrorToast(true);
      return false;
    }

    return true;
  };

  const user = {
    user_NAME: username,
    user_SURNAME: surname,
    user_EMAIL: email,
    user_PHONE: phone,
    user_GROUP_ID: 1,
    user_PWD: password,
    user_ROLE_ID: roleId,
  };

  const onRegisterPress = useCallback(async () => {
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      const res = await registerUser(user);
      console.log("result headset login: ----------------");
      console.log(res);

      // Succès
      setToastMessage("Compte créé avec succès !");
      setShowSuccessToast(true);

      // Réinitialiser le formulaire
      setUsername("");
      setSurname("");
      setPhone("");
      setEmail("");
      setPassword("");
      setConfPassword("");
      setRoleId("");

    } catch (error) {
      console.log("Registration failed:", error);

      // Gestion des différents types d'erreurs
      if (error instanceof Error) {
        setToastMessage(error.message || "Erreur lors de la création du compte");
      } else if (error.response && error.response.data && error.response.data.message) {
        setToastMessage(error.response.data.message);
      } else {
        setToastMessage("Une erreur inattendue s'est produite");
      }
      setShowErrorToast(true);
    } finally {
      setIsLoading(false);
    }
  }, [username, surname, email, phone, roleId, password, confPassword]);

  // Auto-hide toasts after 5 seconds
  useEffect(() => {
    if (showSuccessToast) {
      const timer = setTimeout(() => {
        setShowSuccessToast(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showSuccessToast]);

  useEffect(() => {
    if (showErrorToast) {
      const timer = setTimeout(() => {
        setShowErrorToast(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showErrorToast]);

  // ✅ si on n'a pas encore lu le rôle, ne rien rendre
  if (userlvl === null) {
    return null;
  }

  // ✅ si pas super admin
  if (userlvl !== 1) {
    return <Navigate to="/landing" />;
  }

  return (
    <React.Fragment>
      {/* Toast de succès */}
      <div
        style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 9999,
        }}
      >
        <Toast isOpen={showSuccessToast}>
          <ToastHeader
            icon="success"
            toggle={() => setShowSuccessToast(false)}
            style={{ backgroundColor: '#d4edda', color: '#155724' }}
          >
            Succès
          </ToastHeader>
          <ToastBody style={{ backgroundColor: '#d4edda', color: '#155724' }}>
            {toastMessage}
          </ToastBody>
        </Toast>
      </div>

      {/* Toast d'erreur */}
      <div
        style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 9999,
        }}
      >
        <Toast isOpen={showErrorToast}>
          <ToastHeader
            icon="danger"
            toggle={() => setShowErrorToast(false)}
            style={{ backgroundColor: '#f8d7da', color: '#721c24' }}
          >
            Erreur
          </ToastHeader>
          <ToastBody style={{ backgroundColor: '#f8d7da', color: '#721c24' }}>
            {toastMessage}
          </ToastBody>
        </Toast>
      </div>

      <div
        className="bg-pattern"
        style={{ height: "100vh", overflow: "hidden" }}
      >
        <div className="bg-overlay"></div>
        <div className="account-pages pt-5">
          <Container>
            <Row className="justify-content-center">
              <Col lg={6} md={8} xl={4}>
                <Card
                  className="mt-5"
                  style={{ maxHeight: "70vh", overflowY: "auto" }}
                >
                  <CardBody className="p-4">
                    <div className="text-center">
                      <img
                        src="/iXiVERSE-NEON.png"
                        alt="test"
                        height="25%"
                        width="25%"
                      />
                      <h3>iXiMANAGER</h3>
                    </div>

                    <h4 className="font-size-18 text-muted text-center mt-2">
                      Création de compte
                    </h4>
                    <form className="form-horizontal" action="#">
                      <Row>
                        <Col md={12}>
                          <div className="mb-4">
                            <label className="form-label" htmlFor="username">
                              Nom
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="username"
                              placeholder="Enter username"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                              disabled={isLoading}
                            />
                          </div>
                          <div className="mb-4">
                            <label className="form-label" htmlFor="surname">
                              Prénom
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="surname"
                              placeholder="Enter surname"
                              value={surname}
                              onChange={(e) => setSurname(e.target.value)}
                              disabled={isLoading}
                            />
                          </div>
                          <div className="mb-4">
                            <label className="form-label" htmlFor="useremail">
                              Email
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="useremail"
                              placeholder="Enter email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              disabled={isLoading}
                            />
                          </div>
                          <div className="mb-4">
                            <label className="form-label" htmlFor="phone">
                              Téléphone
                            </label>
                            <input
                              type="tel"
                              className="form-control"
                              id="phone"
                              placeholder="Enter phone number"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                              disabled={isLoading}
                            />
                          </div>
                          <div className="mb-4" title="1=Super Admin | 2=Admin | 3=Manager | 4=Créateur | 5=Utilisateur">
                            <label className="form-label" htmlFor="roleId">
                              Role ID ℹ️
                            </label>
                            <select
                              className="form-control"
                              id="roleId"
                              value={roleId}
                              onChange={(e) => setRoleId(Number(e.target.value))}
                              disabled={isLoading}
                            >
                              <option value={5}>Utilisateur</option>
                              <option value={4}>Créateur</option>
                              <option value={3}>Manager</option>
                              <option value={2}>Admin</option>
                              <option value={1}>Super Admin</option>
                            </select>
                          </div>
                          {/*<div className="mb-4" 
                          title="1=Super Admin | 2=Admin | (3=Manager) | 4=Créateur | 5=Utilisateur">
                            <label className="form-label" htmlFor="roleId">
                              Role ID ℹ️
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id="roleId"
                              placeholder="Enter role ID"
                              value={roleId}
                              onChange={(e) => setRoleId(parseInt(e.target.value) || "")}
                              disabled={isLoading}
                            />
                          </div*/}
                          <div className="mb-4">
                            <label
                              className="form-label"
                              htmlFor="userpassword"
                            >
                              Mot de passe
                            </label>
                            <InputGroup>
                              <input
                                type={passwordVisible ? "text" : "password"}
                                className="form-control"
                                id="userpassword"
                                placeholder="Enter password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                disabled={isLoading}
                              />
                              <InputGroupText
                                onClick={togglePasswordVisibility}
                                style={{ cursor: 'pointer' }}
                              >
                                {passwordVisible ? "Hide" : "Show"}
                              </InputGroupText>
                            </InputGroup>
                          </div>
                          <div className="mb-4">
                            <label
                              className="form-label"
                              htmlFor="confirmPassword"
                            >
                              Confirmer le mot de passe
                            </label>
                            <InputGroup>
                              <input
                                type={confPasswordVisible ? "text" : "password"}
                                className="form-control"
                                id="confirmPassword"
                                placeholder="Confirm password"
                                value={confPassword}
                                onChange={(e) =>
                                  setConfPassword(e.target.value)
                                }
                                disabled={isLoading}
                              />
                              <InputGroupText
                                onClick={toggleConfPasswordVisibility}
                                style={{ cursor: 'pointer' }}
                              >
                                {confPasswordVisible ? "Hide" : "Show"}
                              </InputGroupText>
                            </InputGroup>
                          </div>
                          {/*<div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="term-conditionCheck"
                              disabled={isLoading}
                            />
                            <label
                              className="form-check-label fw-normal"
                              htmlFor="term-conditionCheck"
                            >
                              I accept{" "}
                              <Link to="#" className="text-primary">
                                Terms and Conditions
                              </Link>
                            </label>
                          </div>*/}
                          <div className="d-grid mt-4">
                            <button
                              type="button"
                              className="btn btn-primary waves-effect waves-light"
                              onClick={onRegisterPress}
                              disabled={isLoading}
                            >
                              {isLoading ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                  Creating...
                                </>
                              ) : (
                                "Register"
                              )}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p className="text-white-50">
                    Already have an account ?
                    <Link to={`/auth-login`} className="fw-medium text-primary">
                      {" "}
                      Login{" "}
                    </Link>{" "}
                  </p>
                  <p className="text-white-50">
                    © {new Date().getFullYear()} Upzet. Crafted with{" "}
                    <i className="mdi mdi-heart text-danger"></i> by
                    Themesdesign
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Register;